export const OPEN_SHEET_VIEWER = "OPEN_SHEET_VIEWER";
export const CLOSE_SHEET_VIEWER = "CLOSE_SHEET_VIEWER";
